/**
 * Article rédigé le 2026-09-06 à partir de sources web ouvertes et vérifiées automatiquement
 * (7 URL testées, révisé après re-vérification). Daté au moment des faits : 2026-06-23.
 * À relire avant/après mise en ligne. Format : voir src/blog/README.md
 */
export default {
  "slug": "vivatech-2026-percipio-robotics-startups-bfc",
  "title": "VivaTech 2026 : Percipio Robotics et 15 autres start-ups BFC à Paris",
  "excerpt": "Du 17 au 20 juin, la dixième édition de VivaTech a réuni 200 000 visiteurs Porte de Versailles. Sur 75 m², la Bourgogne-Franche-Comté y a aligné seize start-ups, dont la microrobotique bisontine.",
  "seoTitle": "VivaTech 2026 : Percipio Robotics à Paris",
  "seoDescription": "Du 17 au 20 juin 2026, la Bourgogne-Franche-Comté a aligné seize start-ups sur 75 m² à VivaTech, dont la microrobotique bisontine de Percipio Robotics.",
  "category": "evenements",
  "tags": [
    "VivaTech",
    "Percipio Robotics",
    "French Tech BFC",
    "Microrobotique",
    "Hors Besançon"
  ],
  "author": "jimmy",
  "publishedAt": "2026-06-23",
  "updatedAt": "2026-06-23",
  "featured": false,
  "cover": {
    "image": "/img/blog/paris-salon-vivatech-2025-20.jpg",
    "credit": "Photo : Paris - Salon VivaTech 2025 — Peter Potrowl, CC BY-SA 4.0, via Wikimedia Commons",
    "alt": "Vue plongeante sur un hall animé de Paris Expo Porte de Versailles pendant le salon VivaTech : allées parcourues de visiteurs entre les stands lumineux des exposants, avec les bannières de pavillons collectifs (China Pavillon, Le Village, swisstech, Huawei, AI Avenue) suspendues au-dessus des allées"
  },
  "content": [
    {
      "type": "lead",
      "text": "Du 17 au 20 juin, VivaTech a fêté sa dixième édition à Paris Expo Porte de Versailles. La Région Bourgogne-Franche-Comté, l'AER BFC et La French Tech BFC y ont réuni seize start-ups régionales, au stand référencé 2H48 par La French Tech BFC[^3] et « H48 », pour 75 m², par le communiqué de la Région[^4]. Parmi elles, deux entreprises bisontines : Livdeo, éditeur de l'assistant de réunion Dicte.ai[^7], et Percipio Robotics, seule spécialiste de la microrobotique, installée sur [le technopôle TEMIS](/blog/temis-technopole-startups-deeptech-besancon)."
    },
    {
      "type": "keyfacts",
      "title": "En bref",
      "facts": [
        {
          "label": "Quoi",
          "value": "10e édition de VivaTech, avec un pavillon régional Bourgogne-Franche-Comté (stand 2H48, 75 m²)"
        },
        {
          "label": "Quand",
          "value": "Du mercredi 17 au samedi 20 juin 2026"
        },
        {
          "label": "Où",
          "value": "Paris Expo Porte de Versailles"
        },
        {
          "label": "Qui",
          "value": "Région BFC, AER Bourgogne-Franche-Comté et La French Tech BFC, avec seize start-ups"
        },
        {
          "label": "Pour qui",
          "value": "Investisseurs, grands groupes, médias et décideurs ; ouverture au grand public le samedi"
        }
      ]
    },
    {
      "type": "h2",
      "text": "Une dixième édition à 200 000 visiteurs"
    },
    {
      "type": "p",
      "text": "Le bilan publié par les organisateurs donne la mesure de l'événement : plus de 200 000 visiteurs venus de 165 nationalités et 60 pavillons de pays, plus de 4 500 exposants dont 61 % d'internationaux, plus de 15 000 start-ups présentes et plus de 1 155 intervenants[^1]. L'Allemagne était pays de l'année et l'Inde partenaire IA de l'édition ; les thématiques mises en avant allaient de l'IA et la productivité à la cybersécurité, la greentech, le spatial et la deeptech[^1]. Emmanuel Macron et le Premier ministre indien Narendra Modi ont visité le salon, où figuraient aussi au programme Jeff Bezos, Yann LeCun, Tim Berners-Lee ou Bernard Arnault[^1]."
    },
    {
      "type": "p",
      "text": "C'est dans ce volume que se glissait le pavillon régional, opéré par l'AER Bourgogne-Franche-Comté en partenariat avec [La French Tech Bourgogne-Franche-Comté](https://lafrenchtechbfc.fr/actualites/ecosysteme/vivatech-2026-decouvrez-les-startups-de-bourgogne-franche-comte-qui-exposeront-en-juin/)[^3]. Le président de Région Jérôme Durain, attendu pour l'inauguration du stand le mercredi 17 juin[^4], résumait ainsi l'intention avant l'ouverture : « VivaTech, c'est le rendez-vous mondial de l'innovation. Et la Bourgogne-Franche-Comté y est, pas pour faire de la figuration, mais parce que nos start-up ont des solutions qui comptent. »[^4] La collectivité rappelle avoir financé, depuis 2022, plus de 420 porteurs de projets d'innovation pour près de 27 millions d'euros, auxquels s'ajoutent 336 projets soutenus via France 2030 régionalisé[^4]."
    },
    {
      "type": "h2",
      "text": "Seize start-ups, de l'IA à la santé"
    },
    {
      "type": "p",
      "text": "La sélection régionale couvrait un spectre volontairement large[^2][^3] :"
    },
    {
      "type": "ul",
      "items": [
        "**IA et data** : Astus Tech (agent d'IA pour les professionnels de la paie) et Brainytech (IA frugale, SaaS écoresponsable)",
        "**Santé et medtech** : Crossject (administration de médicament sans aiguille) et Abeye, dont la technologie de neurovision Lexilens vise le confort de lecture",
        "**Industrie et robotique** : [Percipio Robotics](/blog/micronora-2024-microns-or-jumeau-numerique) et Emiotech (maîtrise des équipements, réduction des arrêts de production)",
        "**Énergie et environnement** : MINCATEC Energy (systèmes énergétiques miniaturisés et intelligents) et IMACT (bâtiments existants rendus intelligents en connectant les équipements sans les remplacer)",
        "**Autres solutions** : SECU-RAT, Quai des Notaires, 3E Innovation, Shopcaisse, Winer, [Livdeo](/blog/french-tech-night-2025-besancon-bfc20), AUM Biosync et BatiFire, que la Région range dans cinq autres familles — « CleanTech », « Legaltech & services », « Retail & expérience client », « Performance humaine & organisation » et « Sécurité & bâtiment »[^2][^4]"
      ]
    },
    {
      "type": "p",
      "text": "Un détail complique la lecture des listes publiées : une même entreprise apparaît tantôt sous son nom de société, tantôt sous celui de son produit. La presse régionale cite Lexilens et Livdeo[^2], là où La French Tech BFC référence Abeye et Dicte.ai[^3] : Lexilens est la technologie brevetée d'Abeye, et Dicte.ai l'application de l'éditeur bisontin Livdeo[^7]. Le total reste de seize exposants — même si le communiqué régional, dans son encadré institutionnel, évoque de son côté « 14 start-up »[^4]."
    },
    {
      "type": "h2",
      "text": "Percipio Robotics, la microtechnique bisontine dans l'allée"
    },
    {
      "type": "p",
      "text": "Pour Besançon, deux entreprises étaient annoncées sur le stand : Livdeo, éditeur bisontin de l'assistant de réunion Dicte.ai[^7], et Percipio Robotics, seule à relever des microtechniques. Installée sur le technopôle TEMIS, celle-ci conçoit des machines de micro-assemblage de précision, autour de pinces piézoélectriques brevetées : le Piezogripper, pour des pièces de 5 micromètres à 5 millimètres, et le Tulipgripper, modèle plus robuste destiné aux composants de 50 micromètres à 10 millimètres[^5]. Ses marchés : semi-conducteurs en premier lieu, puis photonique, horlogerie, électronique, électromécanique et médical, cibles identifiées dans son plan de diversification[^5]. Le portrait publié par *Traces Écrites* en mars 2025 faisait état d'une quarantaine de salariés et de 67 machines livrées depuis 2017 à un fabricant italien de semi-conducteurs, sur un contrat signé en 2016[^5]."
    },
    {
      "type": "p",
      "text": "On notera que la fiche du pavillon régional décrivait l'entreprise comme un spécialiste de « robots autonomes intelligents » pour la logistique et la production[^3] — formulation générique qui rend mal compte de son cœur de métier réel, le micro-assemblage sous microscope[^5]. Percipio Robotics était annoncée sur les deux premiers jours, mercredi 17 et jeudi 18 juin, Dicte.ai sur les deux derniers[^3]."
    },
    {
      "type": "h2",
      "text": "Six jours plus tôt, l'IA se discutait à la CCI de Besançon"
    },
    {
      "type": "p",
      "text": "Le calendrier bisontin donne à cette semaine parisienne un relief particulier. Le 11 juin, soit six jours avant l'ouverture de VivaTech, la CCI de Besançon accueillait la troisième édition du [Printemps de l'IA](https://www.macommune.info/la-3e-edition-du-printemps-de-lia-fait-son-retour-a-la-cci-de-besancon/), organisée par le Pôle des Microtechniques avec [l'institut FEMTO-ST](/blog/femto-st-besancon-capitale-microtechniques), autour de l'intégration de l'IA dans les systèmes industriels et de la question de la souveraineté[^6]. L'édition 2025 avait rassemblé 200 participants, 21 exposants et 21 intervenants[^6] ; parmi les animateurs d'ateliers de 2026 figurait Dicte.ai[^6], que l'on retrouvait quelques jours plus tard sur le stand 2H48[^3]."
    },
    {
      "type": "p",
      "text": "Les deux rendez-vous ne jouent pas dans la même catégorie, et c'est l'intérêt de les regarder ensemble : l'un travaille l'adoption, en petit comité, avec les PME industrielles du bassin ; l'autre la visibilité et l'accès aux investisseurs, à l'échelle d'un salon qui compte ses visiteurs par centaines de milliers[^1]. Cette lecture relève de l'analyse : aucun bilan chiffré propre au pavillon régional n'a été publié à ce stade."
    },
    {
      "type": "callout",
      "tone": "info",
      "title": "Pourquoi ça compte pour Besançon",
      "text": "Deux des seize start-ups du stand étaient bisontines, mais une seule relève directement des microtechniques — et elle n'y était annoncée que deux jours sur quatre. C'est peu au regard du poids du secteur sur TEMIS, mais c'est aussi le signe que la vitrine régionale s'est élargie au-delà de la mécanique de précision, vers l'IA, la santé et l'énergie. Le vrai indicateur ne sera pas le nombre de badges scannés : ce sera celui des start-ups locales candidates à l'édition 2027."
    },
    {
      "type": "h2",
      "text": "Ce qu'il faudra vérifier"
    },
    {
      "type": "p",
      "text": "À ce jour, ni la Région, ni l'AER BFC, ni La French Tech BFC n'ont diffusé de bilan chiffré de leur présence : contacts qualifiés, rendez-vous investisseurs, retombées commerciales. Nous avons sollicité Percipio Robotics ; nous complèterons cet article si un retour nous parvient. La prochaine édition de VivaTech est annoncée du 16 au 19 juin 2027[^1] : d'ici là, le meilleur baromètre de l'écosystème bisontin restera ce qui se passe le reste de l'année, sur TEMIS et à la CCI, plutôt que quatre jours dans un hall parisien."
    }
  ],
  "references": [
    {
      "id": 1,
      "title": "VivaTech 2026 celebrates its 10th anniversary with a record-breaking edition surpassing 200,000 visitors",
      "publisher": "VivaTech",
      "url": "https://vivatech.com/media/press-releases/cp-bilan",
      "type": "official",
      "date": "2026-06-20"
    },
    {
      "id": 2,
      "title": "Seize start-ups de la Région Bourgogne Franche-Comté au salon parisien VivaTech 2026",
      "publisher": "macommune.info",
      "url": "https://www.macommune.info/16-start-ups-de-la-region-bourgogne-franche-comte-au-salon-parisien-vivatech-2026/",
      "type": "press",
      "date": "2026-06-03"
    },
    {
      "id": 3,
      "title": "VivaTech 2026 : découvrez les startups de Bourgogne-Franche-Comté qui exposeront en juin",
      "publisher": "La French Tech Bourgogne-Franche-Comté",
      "url": "https://lafrenchtechbfc.fr/actualites/ecosysteme/vivatech-2026-decouvrez-les-startups-de-bourgogne-franche-comte-qui-exposeront-en-juin/",
      "type": "official",
      "date": "2026-04-10"
    },
    {
      "id": 4,
      "title": "Innovation : la Région Bourgogne-Franche-Comté participe à VivaTech 2026",
      "publisher": "Infos Dijon",
      "url": "https://www.infos-dijon.com/news/bourgogne-franche-comte/bourgogne-franche-comte/innovation-la-region-bourgogne-franche-comte-participe-a-vivatech-2026-1780696800.html",
      "type": "press",
      "date": "2026-06-08"
    },
    {
      "id": 5,
      "title": "Percipio Robotics, l'expert du micro-assemblage de Besançon, mis au défi du renouvellement de ses marchés",
      "publisher": "Traces Écrites News",
      "url": "https://www.tracesecritesnews.fr/actualite/percipio-robotics-l-expert-du-micro-assemblage-de-besancon-au-defi-du-renouvellement-de-ses-marches-222058",
      "type": "press",
      "date": "2025-03-19"
    },
    {
      "id": 6,
      "title": "La 3e édition du Printemps de l'IA fait son retour à la CCI de Besançon",
      "publisher": "macommune.info",
      "url": "https://www.macommune.info/la-3e-edition-du-printemps-de-lia-fait-son-retour-a-la-cci-de-besancon/",
      "type": "press",
      "date": "2026-06-04"
    },
    {
      "id": 7,
      "title": "Au Printemps de l'IA de Besançon, des « offreurs de solutions » mettent l'intelligence artificielle au service des PME industrielles",
      "publisher": "Traces Écrites News",
      "url": "https://www.tracesecritesnews.fr/actualite/au-printemps-de-l-ia-de-besancon-des-offreurs-de-solutions-mettent-l-intelligence-artificielle-au-service-des-pme-industrielles-222774",
      "type": "press",
      "date": "2025-04-15"
    }
  ]
};
